{
  "alert": "Uyarı",
  "dismiss": "Kapat"
}
